import { IResponseModel } from "../../IResponseModel";

export class EmailVerificationResponse implements IResponseModel {
    new_token: string;
}